import React from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
//import { useLocalization } from "gatsby-theme-i18n"
import { useI18next } from "gatsby-plugin-react-i18next"
import { CmsImage } from "@bw/bits"
import { useTranslation } from "react-i18next"
import parse from "html-react-parser"
import { button, small, fill } from "../../bits/button/Button.module.css"
import * as css from "./Popup.module.css"

const Popup = ({ location }) => {
  //const { locale } = useLocalization()
  const { language: locale } = useI18next()
  const { t } = useTranslation()
  const [visible, setVisible] = React.useState(false)

  const { popups } = useStaticQuery(graphql`
    query AllCollectionPopupsQuery {
      popups: allCollectionPopups {
        nodes {
          id
          body
          details
          button_entry {
            url
          }
          button_isExternal
          button_openInModal
          button_linkText
          button_linkType {
            value
          }
          button_url
          display_on {
            value
          }
          image {
            alt
            localImage {
              childImageSharp {
                gatsbyImageData(width: 280)
              }
            }
          }
          title
          locale
          display_on {
            value
          }
          entries {
            url
          }
        }
      }
    }
  `)

  /*
   * Chose the right popup
   */
  const popup = React.useMemo(() => {
    if (!location?.pathname) {
      return null
    }

    const pathname =
      location.pathname === "/" ? "/" : location.pathname.slice(0, -1)

    return popups.nodes.reduce((acc, popup) => {
      if (popup.locale !== locale) {
        return acc
      }

      if (popup.display_on.value === "website" && acc === null) {
        // this popup is visible on all pages
        acc = popup
      }

      if (popup.display_on.value === "entries") {
        const paths = popup.entries.map(e => e.url)
        if (paths.includes(pathname)) {
          acc = popup
        }
      }

      return acc
    }, null)
  }, [popups, locale, location?.pathname])

  const handleClose = React.useCallback(() => {
    if (popup?.id) {
      sessionStorage.setItem(popup?.id, "closed")
    }
    setVisible(false)
  }, [popup?.id])

  React.useEffect(() => {
    if (!sessionStorage.getItem(popup?.id)) {
      setVisible(true)
    }
  }, [popup?.id])

  if (!popup) {
    return null
  }

  if (!visible) {
    return null
  }

  return (
    <div className={`${css.wrapper} popup`}>
      <button className={css.close} onClick={handleClose}>
        {t("menu.close")}
      </button>
      <LinkOrAnchor popup={popup} handleClose={handleClose}>
        <div>
          {popup.image && <CmsImage src={popup.image} alt={popup.image?.alt} />}
          {popup.title && <div className={css.title}>{popup.title}</div>}
          {popup.body && <div>{parse(popup.body)}</div>}
          {popup.button_linkText && (
            <div className={`${button} ${small} ${fill} ${css.button}`}>
              {popup.button_linkText}
            </div>
          )}
          {popup.details && <small>{parse(popup.details)}</small>}
        </div>
      </LinkOrAnchor>
    </div>
  )
}

const LinkOrAnchor = ({ popup, children, handleClose }) => {
  if (popup.button_linkType.value === "entry" && !popup.button_isExternal) {
    return (
      <Link to={popup.button_entry.url} onClick={handleClose} target="_blank">
        {children}
      </Link>
    )
  }

  const url =
    popup.button_linkType.value === "entry"
      ? popup.button_entry.url
      : popup.button_url

  return (
    <a
      href={url}
      onClick={handleClose}
      target={popup.button_isExternal ? "_blank" : null}
    >
      {children}
    </a>
  )
}

export { Popup }
